import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of, switchMap, tap } from 'rxjs';
import { Identifier } from 'src/app/common/models/identifier';
import { SectionType } from 'src/app/common/models/section-type';
import { DetailsService } from 'src/app/common/services/details.service';
import { MatExpansionComponent } from '../mat-expansion.component';

@Component({
  selector: 'rpc-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss'],
})
export class DetailComponent extends MatExpansionComponent {
  irbNumber!: string;
  diseaseGroup: string | null = null;
  diseaseTeam: string | null = null;
  priority: string | null = null;
  linesOfTherapy: string[] = []; //This is also called disease categorization
  isCancerRelatedStudy = false;
  filteredSections: SectionType[] = [];

  private readonly allSections: SectionType[] = [
    { id: 1, title: 'Status', description: 'Status of the study', isExpanded: true },
    { id: 2, title: 'Accrual', description: 'Accruals on the study', isExpanded: true },
    { id: 3, title: 'Protocol Documents', description: 'Protocol documents on the study', isExpanded: true },
    { id: 4, title: 'Disease Group', description: 'Disease Group', isExpanded: true },
    { id: 5, title: 'Disease Team', description: 'Disease Team', isExpanded: true },
    { id: 6, title: 'Priority', description: 'Priority of the study', isExpanded: true },
    { id: 7, title: 'Categorization', description: 'Categorization of the study', isExpanded: true },
  ];


  constructor(
    public activatedRoute: ActivatedRoute,
    private detailsService: DetailsService
  ) {
    super();
    this.irbNumber = this.activatedRoute.snapshot.parent?.params['irbNumber'];

    this.initializeStudyDetails();
  }



  /**
   * Initializes study details after determining if the study is cancer-related.
   * 
   * - First, checks if the study is cancer-related.
   *   - If not cancer-related, filters sections and completes.
   *   - If cancer-related and IRB number is available, fetches detailed study information.
   *   - If IRB number is not available, attempts to retrieve it from the study title endpoint, then fetches study details.
   * - Updates component properties such as disease group, disease team, priority, and lines of therapy based on the fetched details.
   * - Always filters sections at the end of the process.
   *
   * @private
   */
  private initializeStudyDetails(): void {
    this.detailsService.isCancerRelatedStudy(this.irbNumber).pipe(
      tap(isCancer => this.isCancerRelatedStudy = isCancer),
      switchMap(isCancer => {
        if (!isCancer) {
          this.filterSections();
          return of(null);
        }
        return this.detailsService.getStudyDetail(this.irbNumber);
      })
    ).subscribe(detailRes => {
      if (detailRes) {
        this.diseaseGroup = detailRes.diseaseGroup;
        this.diseaseTeam = detailRes.diseaseTeam;
        this.priority = detailRes.priority;
        this.linesOfTherapy = detailRes.linesOfTherapy;
      }
      this.filterSections();
    });
  }

  private filterSections(): void {
    this.filteredSections = this.allSections.filter(section => {
      if (section.id === 4) {
        return this.isCancerRelatedStudy;
      }
      if (section.id === 5) {
        return this.isCancerRelatedStudy && !!this.diseaseTeam;
      }
      return true;
    });
  }


}
